import { render, staticRenderFns } from "./CreatePasswordBox.vue?vue&type=template&id=c6c2ad7a&"
import script from "./CreatePasswordBox.vue?vue&type=script&lang=ts&"
export * from "./CreatePasswordBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports